import { Box, Grid, Typography, alpha, makeStyles } from '@material-ui/core';

import { ReactComponent as MockupIphone } from 'assets/images/mockup-iphone.svg';
import { TemplateInterface } from 'store/reducers/templates';
import { MessageVariables } from 'utils/validators';

import TemplatePreviewCard from './TemplatePreviewCard';

const useStyles = makeStyles(theme => ({
  previewContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    flex: 'none',
  },

  previewHeaderStack: {
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${alpha(theme.palette.primary.main, 0.05)}`,
    borderRadius: 8,
    overflow: 'hidden',
    width: '100%',
    flexShrink: 0,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),

    gap: theme.spacing(2),
  },

  fullWidthCenter: {
    width: '100%',
    overflow: 'hidden',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  mockupContainer: {
    display: 'inline-flex',
    width: '100%',
    maxWidth: 300,

    aspectRatio: '271 / 389',

    justifyContent: 'center',
    position: 'relative',
  },

  mockupSvg: {
    width: '100%',
    height: '100%',
  },

  placeholderBox: {
    position: 'absolute',
    inset: 0,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    textAlign: 'center',

    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },

  title: {
    fontWeight: 500,
  },
}));

interface TemplateMessagePreviewProps {
  whatsappTemplateMessage: TemplateInterface | null;
  messageVariables: MessageVariables | null;
}

function TemplateMessagePreview({
  whatsappTemplateMessage,
  messageVariables,
}: TemplateMessagePreviewProps) {
  const classes = useStyles();

  return (
    <Grid className={classes.previewContainer}>
      <Box className={classes.previewHeaderStack}>
        <Box className={classes.fullWidthCenter}>
          <Box className={classes.mockupContainer}>
            <MockupIphone className={classes.mockupSvg} />

            {whatsappTemplateMessage ? (
              <TemplatePreviewCard
                template={whatsappTemplateMessage}
                messageVariables={messageVariables}
              />
            ) : (
              <Box className={classes.placeholderBox}>
                <Typography
                  variant="body2"
                  className={classes.title}
                  color="textSecondary"
                >
                  Selecione um template
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Grid>
  );
}

export default TemplateMessagePreview;
